import { FC } from 'react';
import {
    Table,
    TableHeading,
    TableData,
    TableCaption,
    TableDataSource,
    TableWrapper
} from './TableEntry.styles';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
    type?: string;
};

export type TableProps = {
    data?: [];
    id?: string;
};

const TableHeader: FC<React.PropsWithChildren<TableProps>> = ({ data, id }) => (
    <thead>
        <tr>
            {data?.map((cellData: string, key: number) => (
                <TableHeading scope="col" key={`tablehead-${id}-row-${key}`}>
                    {cellData}
                </TableHeading>
            ))}
        </tr>
    </thead>
);

const TableBody: FC<React.PropsWithChildren<TableProps>> = ({ data, id }) => {
    return (
        <tbody>
            {data?.map(
                (
                    rowData: [],
                    key: number // Row loop
                ) => (
                    <tr key={`table-${id}-row-${key}`}>
                        {rowData?.map(
                            (
                                cellData: string,
                                key: number // Cell loop
                            ) => (
                                <TableData key={`table-${id}-cell-${key}`}>
                                    {cellData}
                                </TableData>
                            )
                        )}
                    </tr>
                )
            )}
        </tbody>
    );
};

const TableEntry: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    // // Here we're assuming the first array is the heading row
    const [tableHeaders, ...tableBody] =
        nodeData.data?.target.fields.table?.tableData || [];
    // // Now let's grab the ID of said table (for React array keys={bleh})
    const id = nodeData.data?.target.sys?.id;

    return (
        <TableWrapper>
            <Table>
                <TableCaption>
                    {nodeData.data?.target.fields.table?.tableTitle}
                </TableCaption>
                <TableHeader data={tableHeaders} id={id} />
                <TableBody data={tableBody} id={id} />
            </Table>
            <TableDataSource>
                {nodeData.data?.target.fields.source}
            </TableDataSource>
        </TableWrapper>
    );
};

export default TableEntry;
